var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item"},[_c('div',{staticClass:"slot-wrapper"},[_vm._t("icon")],2),_c('div',{staticClass:"info"},[_c('h4',{staticClass:"title label__medium"},[_vm._v(" "+_vm._s(_vm.title)+" "),_vm._t("sub-title")],2),_c('span',{staticClass:"value label__medium",class:_vm.color,attrs:{"title":_vm.data}},[_vm._v(_vm._s(_vm.data))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }